import React from "react";
import "./Home.css";
import RightImage from "../../images/home1.png";

export default function Home() {
  return (
    <main className="home">
      <div className="home-inner">
        <section className="home-left">
          <p className="home-kicker">PhD in Economics</p>
          <h1 className="home-title">Marian Melnyk</h1>
          <p className="home-blurb">
            I am a Ph.D. candidate in Economics at the CUNY Graduate Center. My
            research studies how institutions, labor markets, and technology
            shape productivity, economic participation, and long-run
            development. I work primarily at the intersection of labor
            economics, macroeconomics, and political economy, often using
            historical settings to study broader questions about the well-being
            of individuals and societies.
          </p>
        </section>

        <aside className="home-right">
          <img src={RightImage} alt="" />
        </aside>
      </div>
    </main>
  );
}
